// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/service_account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Subject } from "./identity_pb.js";

/**
 * @generated from message gitpod.v1.CreateServiceAccountRequest
 */
export class CreateServiceAccountRequest extends Message<CreateServiceAccountRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * valid_until specifies when this service account expires.
   * Note: In the current design, the service account itself has an expiry.
   * All authentication using this service account will fail after this time.
   *
   * @generated from field: google.protobuf.Timestamp valid_until = 3;
   */
  validUntil?: Timestamp;

  constructor(data?: PartialMessage<CreateServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "valid_until", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountRequest | PlainMessage<CreateServiceAccountRequest> | undefined, b: CreateServiceAccountRequest | PlainMessage<CreateServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountResponse
 */
export class CreateServiceAccountResponse extends Message<CreateServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<CreateServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountResponse | PlainMessage<CreateServiceAccountResponse> | undefined, b: CreateServiceAccountResponse | PlainMessage<CreateServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountsRequest
 */
export class ListServiceAccountsRequest extends Message<ListServiceAccountsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListServiceAccountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountsRequest | PlainMessage<ListServiceAccountsRequest> | undefined, b: ListServiceAccountsRequest | PlainMessage<ListServiceAccountsRequest> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountsResponse
 */
export class ListServiceAccountsResponse extends Message<ListServiceAccountsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ServiceAccount service_accounts = 2;
   */
  serviceAccounts: ServiceAccount[] = [];

  constructor(data?: PartialMessage<ListServiceAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "service_accounts", kind: "message", T: ServiceAccount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountsResponse | PlainMessage<ListServiceAccountsResponse> | undefined, b: ListServiceAccountsResponse | PlainMessage<ListServiceAccountsResponse> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountRequest
 */
export class GetServiceAccountRequest extends Message<GetServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  constructor(data?: PartialMessage<GetServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountRequest | PlainMessage<GetServiceAccountRequest> | undefined, b: GetServiceAccountRequest | PlainMessage<GetServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountResponse
 */
export class GetServiceAccountResponse extends Message<GetServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<GetServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountResponse | PlainMessage<GetServiceAccountResponse> | undefined, b: GetServiceAccountResponse | PlainMessage<GetServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateServiceAccountRequest
 */
export class UpdateServiceAccountRequest extends Message<UpdateServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  /**
   * Optional fields for update
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Note: valid_until is immutable and cannot be updated
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateServiceAccountRequest | PlainMessage<UpdateServiceAccountRequest> | undefined, b: UpdateServiceAccountRequest | PlainMessage<UpdateServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(UpdateServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateServiceAccountResponse
 */
export class UpdateServiceAccountResponse extends Message<UpdateServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<UpdateServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateServiceAccountResponse | PlainMessage<UpdateServiceAccountResponse> | undefined, b: UpdateServiceAccountResponse | PlainMessage<UpdateServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(UpdateServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountRequest
 */
export class DeleteServiceAccountRequest extends Message<DeleteServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  constructor(data?: PartialMessage<DeleteServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountRequest | PlainMessage<DeleteServiceAccountRequest> | undefined, b: DeleteServiceAccountRequest | PlainMessage<DeleteServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountResponse
 */
export class DeleteServiceAccountResponse extends Message<DeleteServiceAccountResponse> {
  constructor(data?: PartialMessage<DeleteServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountResponse | PlainMessage<DeleteServiceAccountResponse> | undefined, b: DeleteServiceAccountResponse | PlainMessage<DeleteServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ServiceAccount
 */
export class ServiceAccount extends Message<ServiceAccount> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 5;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 7;
   */
  validUntil?: Timestamp;

  constructor(data?: PartialMessage<ServiceAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ServiceAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "creator", kind: "message", T: Subject },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "valid_until", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ServiceAccount {
    return new ServiceAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ServiceAccount {
    return new ServiceAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ServiceAccount {
    return new ServiceAccount().fromJsonString(jsonString, options);
  }

  static equals(a: ServiceAccount | PlainMessage<ServiceAccount> | undefined, b: ServiceAccount | PlainMessage<ServiceAccount> | undefined): boolean {
    return proto3.util.equals(ServiceAccount, a, b);
  }
}

